import React from "react";

const NotFound = () => {
  return (
    <div>
      <img className="image404" src="/images/404.jpg" alt="Not Found" />
    </div>
  );
};

export default NotFound;
